import { Component, Input } from '@angular/core';

import {
  FormControl,
  ControlContainer,
  FormGroupDirective,
} from '@angular/forms';

@Component({
    selector: 'ngx-textarea',
    styleUrls: ['./textarea.component.scss'],
    templateUrl: './textarea.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class TextareaComponent {
  @Input() type: string = 'text';
  @Input() rows: number = 3;
  @Input() border: boolean = true;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() controlName: string;
  @Input() control: FormControl;

  constructor(
  ) {
  }
}
